import { render } from "./Header.vue?vue&type=template&id=2a574d67&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=2a574d67&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src998676681/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a574d67"]])

export default __exports__